import type { RouteDefinition } from "./route-definition.ts";

export const gameRoutes = {
  "game.home": {
    path: "/:gameSlug",
    scope: "game",
    bucket: "catalog",
    entry: "nav",
    disposition: "page",
  },
  "game.forum": {
    path: "/:gameSlug/forum",
    scope: "game",
    bucket: "catalog",
    entry: "parent",
    disposition: "page",
  },
  "game.forumPost": {
    path: "/:gameSlug/forum/:postId",
    scope: "game",
    bucket: "catalog",
    entry: "parent",
    disposition: "page",
  },
  "game.wiki": {
    path: "/:gameSlug/wiki",
    scope: "game",
    bucket: "catalog",
    entry: "parent",
    disposition: "page",
  },
  "game.wikiPage": {
    path: "/:gameSlug/wiki/*page",
    scope: "game",
    bucket: "catalog",
    entry: "parent",
    disposition: "page",
  },
  "game.search": {
    path: "/:gameSlug/search",
    scope: "game",
    bucket: "catalog",
    entry: "parent",
    disposition: "page",
  },
  "game.desk": {
    path: "/:gameSlug/desk",
    scope: "game",
    bucket: "catalog",
    entry: "parent",
    disposition: "page",
  },
  "game.submit": {
    path: "/:gameSlug/:league?/submit",
    scope: "game",
    bucket: "catalog",
    entry: "parent",
    disposition: "page",
  },
  "game.report": {
    path: "/:gameSlug/reports/:reportSlug",
    scope: "game",
    bucket: "catalog",
    entry: "parent",
    disposition: "page",
  },
  "game.previewEdit": {
    path: "/:gameSlug/preview/edit",
    scope: "game",
    bucket: "catalog",
    entry: "parent",
    disposition: "page",
  },
  "game.preview": {
    path: "/:gameSlug/:league?/preview",
    scope: "game",
    bucket: "catalog",
    entry: "workflow",
    disposition: "page",
  },
  "game.play": {
    path: "/:gameSlug/:league?/play",
    scope: "game",
    bucket: "catalog",
    entry: "workflow",
    disposition: "page",
  },
  "game.start": {
    path: "/:gameSlug/:league?/start",
    scope: "game",
    bucket: "catalog",
    entry: "workflow",
    disposition: "page",
  },
  "game.playEpisodes": {
    path: "/:gameSlug/:league?/play/episodes",
    scope: "game",
    bucket: "catalog",
    entry: "workflow",
    disposition: "page",
  },
  "game.playRequests": {
    path: "/:gameSlug/:league?/play/requests",
    scope: "game",
    bucket: "catalog",
    entry: "workflow",
    disposition: "page",
  },
  "game.playActivity": {
    path: "/:gameSlug/:league?/play/activity",
    scope: "game",
    bucket: "catalog",
    entry: "workflow",
    disposition: "page",
  },
  "game.league": {
    path: "/:gameSlug/:league",
    scope: "game",
    bucket: "catalog",
    entry: "parent",
    disposition: "page",
  },
} as const satisfies Record<string, RouteDefinition>;
